import styled from 'styled-components/native';
import {Platform, StyleSheet} from 'react-native';
import { FontAwesome5, MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';
import theme from '../../global/styles/theme';

interface TabAreaProps {
  keyboardIsOpen?: boolean;
  appTheme: 'light' | 'dark';
}

export const Button = styled.TouchableOpacity`
  align-items: center;
  flex: 1;
  justify-content: center;
  height: 100%;
  padding: 4px 0px;
`;

export const TabArea = styled.View<TabAreaProps>`
  align-items: center;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundColor};
  flex-direction: column;
  position: absolute;
  bottom: 0px;
  width: 100%;
  opacity: 1;
  height: auto;
  border-top-width: 0.5px;
  border-color: ${({appTheme}) => theme.colors(appTheme).gray[800]};
`;

export const TabCardArea = styled.View`
  align-items: center;
  justify-content: center;
`;

export const TabBarArea = styled.View`
  align-items: center;
  justify-content: center;
`;

export const IconImageLocal = styled.Image`
  height: 22px;
  width: 22px;
`;

export const AdjustBanner = styled.View`
  width: 100%;
  background-color: black;
  align-items: center;
  justify-content: center;
`;

export const Row = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  height: 60px;
  margin-top: 10px;
  margin-bottom: ${Platform.OS === 'ios' ? '30px' : '10px'};
`;

export const IconImageMaterialIcons = styled(MaterialIcons)``;

export const IconImageFont = styled(FontAwesome5)``;

export const IconImageMaterialCommunityIcons = styled(MaterialCommunityIcons)``;

export const styles = StyleSheet.create({
  shadowButton: {
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.34,
    shadowRadius: 6.27,
    elevation: 5,
  },
});
